import { Button } from 'antd';
import styled from 'styled-components';
import { NeutralColors } from 'theme';

const Title = styled.div`
  background-color: ${NeutralColors[80]};
  height: 64px;
  padding: 16px;
  display: grid;
  grid-template-areas: 'return title add-on';
  grid-template-columns: 40px max-content 40px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  .fms-typography {
    color: ${NeutralColors[0]} !important;
    margin-bottom: 0 !important;
    grid-area: title;
    justify-content: center;
  }
`;

const ReturnButton = styled(Button)`
  color: ${NeutralColors[0]};
  font-size: 16px;
  justify-self: start;
  grid-area: return;
  background-color: ${NeutralColors[80]};
  border-color: ${NeutralColors[80]};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 24px;
    width: 24px;
    fill: currentColor;
  }

  &:hover {
    color: ${NeutralColors[0]} !important;
    border-color: transparent !important;
  }
`;

export { ReturnButton, Title };
